import React from 'react';
import { Icon } from './Icon.js';
export const IconLabel3Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m8.695,1.592c-.332-.376-.811-.592-1.312-.592H2.75C1.233,1,0,2.233,0,3.75v4.5c0,1.517,1.233,2.75,2.75,2.75h4.632c.502,0,.98-.216,1.312-.592l2.868-3.25c.583-.66.583-1.655,0-2.315l-2.868-3.25Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconLabel3Fill12.js.map